import './lncanada4/style';
import FormStructure from './lncanada4/form_structure';

export default FormStructure;